<template>
  <div
    class="button-check"
    :class="styleDisabled"
    @click="check">

    <font-awesome-icon
      icon="chevron-right"
      size="lg"
      class="icon"
      />
    {{ $l['mapFindPoint']}}
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import _ from 'lodash'

export default {
  mixins: [
    MixinLocale
  ],

  data () {
    return {
      checking: false
    }
  },

  computed: {
    isChecking: function () {
      return this.checking === true
    },

    styleDisabled: function () {
      if (this.isChecking || !this.$store.getters['event/pointCheckable']) {
        return { 'button-disabled': true }
      }
      return {}
    },

    tourism: function () {
      return this.$store.state.tourism.tourism
    },

    quiz: function () {
      return this.$store.state.quiz.quiz
    }
  },

  methods: {
    check: _.throttle(async function () {
      if (!this.isChecking && this.$store.getters['event/pointCheckable']) {
        this.checking = true
        try {
          await this.checkTourismPoint()
          await this.checkQuizPoint()
        } finally {
          this.checking = false
        }
      }
    }, 1000),

    checkTourismPoint: async function () {
      const status = await this.$store.dispatch('tourism/checkPoint')
      if (status) {
        throw status
      }

      if (this.tourism) {
        this.$store.dispatch('popupTourism/show', 'found')
        this.checking = false
        return
      }
    },

    checkQuizPoint: async function () {
      const status = await this.$store.dispatch('quiz/checkPoint')
      if (status) {
        throw status
      }

      if (this.quiz) {
        this.$store.dispatch('popupQuiz/show', 'found')
        await this.$store.dispatch('quiz/fetchHints', this.quiz)
      } else {
        this.$store.dispatch('popupQuiz/show', 'notFound')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.button-check {
  height: $ph-button;
  display: flex;
  justify-content: center;
  align-items: center;
  // background: $peter-liver;
  background: $turquoise;
  color: white;

  &:hover {
    cursor: pointer;
  }
}

.button-disabled {
  background: rgba(0, 0, 0, 0.2);
  &:hover {
    cursor: default;
  }
}

.icon {
  margin-right: 10px;
}
</style>
